module.exports = __webpack_public_path__ + "static/media/sample.f690ee87.csv";